import { Component, Input, OnInit } from '@angular/core';
import { ActionComponent } from 'tuain-ng-forms-lib';
import { NzButtonType, NzButtonShape, NzButtonSize } from "ng-zorro-antd/button";
import { IconDictionaryService } from 'src/app/services/icon-dictionary.service';

@Component({
  selector: 'app-action',
  templateUrl: './app-action.component.html',
  styleUrls: ['./app-action.component.less'],
})
export class AppActionComponent extends ActionComponent {
  icon: String;
  @Input() style = 'primary';
  @Input() showLabel = true;
  @Input() size: NzButtonSize = 'default';
  @Input() nzType: NzButtonType = 'primary';
  @Input() shape: NzButtonShape = null; // 'round';

  constructor(public _iconDictionary: IconDictionaryService) {
    super();
  }

  override start() {
    super.start();
    this.icon = this._iconDictionary.mapIcon(this.action?.iconName);
  }
}

